<template>
    <div class="p-4">
        <div class="flex items-center border-b border-a-brown-d7c7b8 pb-4 justify-center">
            <img class="w-50px" src="../../../../assets/logo/logo-point.svg">
            <div class="lg:flex text-14 text-a-brown-502314 ml-3">
                <div>Your current points </div>
                <div class="text-a-red-d62300 font-bold lg:ml-2">{{FilterNumberFormat(profileExpiringPoint?.point)}} Crow points</div>
            </div>
        </div>
        <div v-if="profileExpiringPoint != null">
            <div v-for="(v,k) in profileExpiringPoint.expiringPointList"
                 :key="k"
                 class="flex justify-between text-14 text-a-brown-502314 mt-4">
                <div>
                    {{lbl.history.expire_text}} {{FilterDateFormatShort2(v.dateExpire)}}
                </div>
                <div class="pl-6 flex-shrink-0">
                    : {{FilterNumberFormat(v.point)}} {{lbl.history.crowns}}
                </div>
            </div>
        </div>
    </div>
</template>
<script>

import BzbsPoint from '@/core/Point/service/BzbsPoint'
//mixin
import LocaleMixin from "@/mixin/LocaleMixin.js";
import ModalMixin from '@/mixin/ModalMixin'

export default {
    mixins: [ModalMixin,LocaleMixin],
    data: function () {
        return {
            profileExpiringPoint: null,
        };
    },
    created: function () {
        this.getExpirePoint();
    },
    methods: {
        getExpirePoint: function () {
            BzbsPoint.apiExpirePoint().subscribe({
                next: (data) => {
                    this.profileExpiringPoint = data;
                    console.log(data);
                },
                error: (err) => {
                    console.log(err);
                    this.errorApi(err);
                },
            });
        },
    },
}
</script>
<style lang="scss" scoped>
</style>
